export enum AuthorizationEvent {
    PickSignup = 'Pick Signup',
    Login = 'Login',
}
